export const isBetPage = (isEditLineIncubator = false): boolean => {
    const {pathname} = window.location;

    return pathname.includes('/play/live') || pathname.includes('/play/express') ||
        pathname.includes('/play/bets') || pathname.includes('/play/results') ||
        (isEditLineIncubator ? pathname.includes('/play/incubator/all') : pathname.includes('/play/incubator'));
};
